<template>
    <!-- DO NOT switch show.bind to if.bind. navItem will not work if if.bind is used -->
    <nav class="navbar navbar-expand-lg px-1 px-md-3 py-0" ref="levelTwoContainer" id="Level_Two_Navbar">
        <!-- Small screen - burger icon menu -->
        <!-- App Menu-->
        <div class="navbar-collapse planner_level w-100 d-flex justify-content-between" id="Level_Two_Menu">
            <div class="navigator d-flex align-items-center gap-2 gap-md-4">
                <div class="d-md-none">
                    <a class="" role="button" @click="toggleAsideNav()">
                        <i
                            class="fas"
                            :title="openAgencyNav ? 'Open side nav' : 'Close side nav'"
                            :class="openAgencyNav ? 'fa-angle-double-left' : 'fa-angle-double-right'"
                        ></i>
                    </a>
                </div>
                <div class="navs d-flex align-items-center">
                    <!-- Left Nav -->
                    <TabsAnimatedHeader
                        :activeItem="getActiveItem"
                        :is-gradient-underline="isPathMessaging"
                        :recalculate-dimensions="connectPermissionLoaded"
                    >
                        <ul class="d-flex">
                            <li
                                v-for="route in router"
                                v-show="showRoute(route.meta.navItem)"
                                :key="route.meta.navItem"
                                :class="`cursor-pointer ${route.meta.menuName === 'Axxess Connect' ? 'me-2' : 'me-2 me-md-4'} ${isActivePath(route.path) ? 'active' : ''}`"
                            >
                                <div class="d-flex">
                                    <button
                                        class="link-btn nav-link menu-link"
                                        @click="goTo(route.path)"
                                        :ref="(el) => addItemRefs(el, route)"
                                    >
                                        <h6
                                            :class="`${isActivePath(route.path) ? 'active' : ''} ${route.meta.menuName === 'Axxess Connect' ? 'd-flex align-items-center' : ''}`"
                                        >
                                            <span
                                                :class="`${isActivePath(route.path) && route.meta.menuName === 'Axxess Connect' ? 'active gradient-nav-text' : ''} nav-text`"
                                            >
                                                {{ route.meta.menuName }}</span
                                            >
                                        </h6>
                                    </button>
                                    <div
                                        class="d-flex phone-pills-padding px-1"
                                        v-if="route.meta.menuName === 'Axxess Connect'"
                                    >
                                        <div
                                            class="d-flex me-1 premium-margin"
                                            v-if="!isOnlyFamilyPortal && !isConnectEnabled"
                                        >
                                            <img
                                                class="ms-1 mb-1 premium-lock-img"
                                                v-tooltip="{
                                                    title: connectLockMessage,
                                                    placement: 'top',
                                                    className: 'lock-premium'
                                                }"
                                                src="../../../../assets/images/premium-lock.png"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </TabsAnimatedHeader>
                </div>
            </div>
            <div>
                <template v-if="showIcons && showUserStatus">
                    <UserProfileManagement />
                </template>

                <ul v-else-if="showIcons" class="d-flex">
                    <li class="me-2" v-if="isConnectEnabled">
                        <MessagesPreview :is-axxess-planner-header="isAxxessPlannerHeader"></MessagesPreview>
                    </li>
                    <li>
                        <span class="px-2 strip-item dropdown app-menu">
                            <a
                                class="dropdown-toggle btn p-0 font-size-sm"
                                href="javascript:void(0);"
                                id="User_Dropdown"
                                role="button"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i class="fas fa-list-ul fa-lg"></i>
                                <!-- <i class="fas fa-caret-down ms-1"></i> -->
                            </a>
                            <div class="dropdown-menu dropdown-menu-end mt-0" aria-labelledby="User_Dropdown">
                                <a
                                    v-if="showEmployeeSearch"
                                    class="dropdown-item"
                                    :class="showEmployees ? 'selected' : ''"
                                    @click="toggleEmployeesMenus()"
                                >
                                    <i class="icon fa fa-search blue-text"></i>
                                    <span class="text-center ps-1 blue-text">Employees</span>
                                </a>
                                <div class="dropdown-divider"></div>
                                <li>
                                    <a
                                        class="dropdown-item"
                                        :class="showPatients ? 'selected' : ''"
                                        @click="togglePatientsMenu()"
                                    >
                                        <i class="icon fa fa-search blue-text"></i>
                                        <span class="text-center ps-1 blue-text">Patients</span>
                                    </a>
                                </li>
                                <div class="dropdown-divider"></div>
                                <li>
                                    <a class="dropdown-item" href="https://community.axxessweb.com/" target="_blank">
                                        <i class="fas fa-users icon pe-1 blue-text"></i>
                                        <span class="text-center blue-text">User Community</span>
                                    </a>
                                </li>
                                <div class="dropdown-divider"></div>
                                <li>
                                    <a class="dropdown-item" @click="displayLiveLoginToken()" v-if="liveLoginData">
                                        <i class="fas fa-key icon pe-1 blue-text"></i>
                                        <span class="text-center blue-text">Support Key</span>
                                    </a>
                                </li>
                            </div>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script lang="ts" src="./PlannerLevelTwo.ts"></script>
<style src="../../../LevelTwo/LevelTwo.scss"></style>
